import { Routes } from '@angular/router';
import { MainPageComponent } from './pages';

export const appRoutes: Routes = [
  {
    path: 'main',
    component: MainPageComponent,
  },
];
